export const isEmailValid = (email: string) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailRegex.test(email)
}

export const isAbsoluteUrl = (url: string) => {
  const absoluteUrlRegex = /^(?:[a-z]+:)?\/\//i
  return absoluteUrlRegex.test(url)
}

export const isDomainValid = (domain: string): boolean => {
  const domainRegex =
    /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/
  return domainRegex.test(domain)
}

/**
 * Strips the protocol (http:// or https://) from a URL string
 * @param url - The URL to strip the protocol from
 * @returns The URL without the protocol
 * @example
 * stripUrlProtocol('https://example.com') // 'example.com'
 * stripUrlProtocol('http://example.com') // 'example.com'
 * stripUrlProtocol('example.com') // 'example.com'
 */
export const stripUrlProtocol = (url: string): string => {
  return url.replace(/^https?:\/\//i, '')
}
